import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import { errorMessage } from '@features/applications';
import axiosInstance from '@server/axiosInstance';
import {  deletePayrollPartnerRoute } from '../api/constants';
import { onboardPackagesList, payrollpartnersList } from '../constants';

type useDeletePayrollPartnerProps = {
    setErrorText: Dispatch<SetStateAction<string>>;
};

export const useDeletePayrollPartner = ({
    setErrorText,
}: useDeletePayrollPartnerProps) => {
    const client = useQueryClient();
    const { mutate: deletePayrollPartner, isLoading: isDeletingPayrollPartner } =
        useMutation({
            mutationFn: (variables: {
                partner_id: number;
                company_id?: number;
            }) =>
                axiosInstance
                    .post(deletePayrollPartnerRoute, variables)
                    .then((res) => res.data),
            onSuccess: (data) => {
                if (data.status === 200) {
                    client.invalidateQueries([payrollpartnersList]);
                    client.invalidateQueries([onboardPackagesList]);
                    setErrorText('');
                } else {
                    setErrorText(data?.message || errorMessage);
                }
            },
            onError: (error: { message?: string }) => {
                setErrorText(error?.message || errorMessage);
            },
        });

    return {
        deletePayrollPartner,
        isDeletingPayrollPartner,
    };
};
